module.exports = __webpack_public_path__ + "static/media/doTERRA-build-guide.4a3cb7d3.pdf";